import React from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useWindowSize } from "go-core/components/useWindowSize";
import { InvoiceApi, InvoiceCalculationType } from "../../../../../../../../../../../services/Api/Organization/types";

interface Props {
	form: UseFormReturn<InvoiceApi>;
}

const InvoiceFormItemsTableHeader = ({ form }: Props) => {
	const { watch } = form;
	const { t } = useTranslation();
	const isMobile = useWindowSize().isMobile;

	return (
		<thead>
			<tr>
				<th className="action" />
				<th style={{ minWidth: isMobile ? "200px" : "unset", width: isMobile ? "unset" : "30%" }}>
					{t("lib:common.word.name")}
				</th>
				<th style={{ minWidth: isMobile ? "100px" : "unset", width: isMobile ? "unset" : "5%" }}>
					{t("modules.invoice.field.pkwiu.title")}
				</th>
				<th style={{ minWidth: isMobile ? "100px" : "unset", width: isMobile ? "unset" : "5%" }}>
					{t("modules.invoice.field.gtu.title")}
				</th>
				<th style={{ minWidth: isMobile ? "100px" : "unset", width: isMobile ? "unset" : "5%" }}>
					{t("common.word.volume")}
				</th>
				<th style={{ minWidth: isMobile ? "100px" : "unset", width: isMobile ? "unset" : "5%" }}>
					{t("common.word.quantity")}
				</th>
				<th style={{ minWidth: isMobile ? "100px" : "unset", width: isMobile ? "unset" : "15%" }}>
					{t("common.word.measure_type")}
				</th>

				<th style={{ minWidth: isMobile ? "120px" : "unset", width: isMobile ? "unset" : "10%" }}>
					{watch("calculation_type") === InvoiceCalculationType.GROSS
						? t("common.word.unit_price_gross_money")
						: t("common.word.unit_price_net_money")}
				</th>
				<th style={{ minWidth: isMobile ? "120px" : "unset", width: isMobile ? "unset" : "10%" }}>
					{watch("calculation_type") === InvoiceCalculationType.GROSS
						? t("modules.invoice.field.price_sum_gross.title")
						: t("modules.invoice.field.price_sum_net.title")}
				</th>
				<th style={{ minWidth: isMobile ? "100px" : "unset", width: isMobile ? "unset" : "15%" }}>
					{t("common.word.vat_rate")} <br />
					{t("common.word.vat")}
				</th>
				<th className="action" />
			</tr>
		</thead>
	);
};

export default InvoiceFormItemsTableHeader;
